import React from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { DateDetails } from './date-details';
import { PurchaseDetails } from './purchase-details';
import { GiftCheckbox } from '../gift-checkbox';
import { Button } from 'ui-components/components/button';
import { useSalesOrderRestrictionsBySOId } from '../../../hooks/entities/selectors/sales-orders';
import { ComponentStates } from '../../../enums/component-states';

import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

import style from './order-summary.module.less';
import { testId } from 'ui-components/services/testid-service';

const messages = defineMessages({
  editButton: {
    description: 'orderSummary.edit',
    defaultMessage: 'Edit',
    id: 'Yu/ecf',
  },
});

export const OrderSummary = ({
  salesOrderId,
  orderDateTime,
  orderGridStatus = '',
  paidDateTime,
  shipByDateTime = '',
  holdUntilDateTime = '',
  amountSummary,
  discounts = emptyArray,
  classes = null,
  isInDrawer = false,
  openEditState = noop,
}) => {
  const salesOrderRestrictions = useSalesOrderRestrictionsBySOId(salesOrderId);
  const readOnlyOrderSummary = salesOrderRestrictions?.amountSummary?.componentState === ComponentStates.ReadOnly;
  const hideGiftCheckbox = salesOrderRestrictions?.isGift?.componentState === ComponentStates.Disabled;

  return (
    <div className={classnames(style['order-summary'], { [style['in-drawer']]: isInDrawer }, classes)} {...testId('order-summary')}>
      <div className={style['order-summary-container']}>
        <div className={style['summary-section']}>
          <DateDetails
            holdUntilDateTime={holdUntilDateTime}
            orderDateTime={orderDateTime}
            orderGridStatus={orderGridStatus}
            paidDateTime={paidDateTime}
            shipByDateTime={shipByDateTime}
          />
        </div>
        <div className={classnames(style['summary-section'], style['section-with-edit-button'])}>
          <PurchaseDetails amountSummary={amountSummary} discounts={discounts} />
          {!isInDrawer && !readOnlyOrderSummary && (
            <Button className={style['edit-button']} onClick={openEditState} theme='link'>
              <FormattedMessage {...messages.editButton} />
            </Button>
          )}
        </div>
      </div>
      {!hideGiftCheckbox && <GiftCheckbox salesOrderId={salesOrderId} />}
    </div>
  );
};

OrderSummary.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  orderDateTime: PropTypes.string.isRequired,
  orderGridStatus: PropTypes.string,
  paidDateTime: PropTypes.string.isRequired,
  shipByDateTime: PropTypes.string,
  holdUntilDateTime: PropTypes.string,
  amountSummary: PropTypes.object.isRequired,
  discounts: PropTypes.array,
  classes: PropTypes.string,
  isInDrawer: PropTypes.bool,
  openEditState: PropTypes.func,
};
